import React from 'react';

// Helpers
import { toHours } from '../../helpers/helpers.js'

// Components
import * as icons from '../Icons/Icons';

const Intro = class Intro extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleNext = this.handleNext.bind(this);

    // Set the initial state
    this.state = {
      permittedItems: [],
      showPreparation: false
    }
  }

  componentDidMount() {
    this.parsePermittedItems();
  }

  componentDidUpdate() {
    const { button, nextStep, parent, statusClass } = this.props;

    if(statusClass === 'slide-active' && parent.state.next !== this.handleNext) {
      parent.setState({
        next: this.handleNext
      });
    }

    if(statusClass === 'slide-active' && parent.state.next !== nextStep) {
      button.disabled = false;
    }
  }

  handleNext() {
    const { nextStep } = this.props;

    if(!this.state.showPreparation) {
      this.setState({
        showPreparation: true
      });
    } else {
      nextStep();
    }
  }

  parsePermittedItems() {
    const { SessionStore } = this.props.store;
    const translation = SessionStore.translation.PermittedItems;
    const { examConfiguration } = this.props;
    const permittedItems = [];

    if(examConfiguration.permittedBathroomBreak) {
      permittedItems.push({
        title: translation.bathroomBreak,
        details: examConfiguration.permittedBathroomBreakInformation
      });
    }

    if(examConfiguration.permittedBlankPaper) {
      permittedItems.push({
        title: translation.blankPaper,
        details: examConfiguration.permittedBlankPaperInformation
      });
    }

    if(examConfiguration.permittedCalculator) {
      permittedItems.push({
        title: translation.calculator,
        details: examConfiguration.permittedCalculatorInformation
      });
    }

    if(examConfiguration.permittedDictionary) {
      permittedItems.push({
        title: translation.dictionary,
        details: examConfiguration.permittedDictionaryInformation
      });
    }

    if(examConfiguration.permittedEarplugs) {
      permittedItems.push({
        title: translation.earplugs,
        details: examConfiguration.permittedEarplugsInformation
      });
    }
    
    if(examConfiguration.permittedFormulaSheet) {
      permittedItems.push({
        title: translation.formulaSheet,
        details: examConfiguration.permittedFormulaSheetInformation
      });
    }
    
    if(examConfiguration.permittedNotes) {
      permittedItems.push({
        title: translation.notes,
        details: examConfiguration.permittedNotesInformation
      });
    }

    if(examConfiguration.permittedTextBook) {
      permittedItems.push({
        title: translation.textbook,
        details: examConfiguration.permittedTextBookInformation
      });
    }
    
    if(examConfiguration.permittedWebsites) {
      permittedItems.push({
        title: translation.websites,
        details: examConfiguration.permittedWebsitesInformation
      });
    }

    if(examConfiguration.permittedOtherItems) {
      permittedItems.push({
        title: translation.other,
        details: examConfiguration.permittedOtherItems
      });
    }

    this.setState({
      permittedItems
    });
  }

  render() {
    const { exam, examConfiguration, statusClass } = this.props;
    const translation = this.props.translation.intro;
    const verifyId = examConfiguration.modalityOptions.verifyId;

    if(!this.state.showPreparation) {
      return (
        <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step5">
          <section className="panel__section">
            <h2 className="panel__title panel__title--alt" id="step5">
              {translation.exam_details_heading}
            </h2>
  
            <ul className="data--alt">
              <li>
                <strong>{translation.exam_details.name}</strong>
                <p>{exam.title}</p>
              </li>
              <li>
                <strong>{translation.exam_details.duration}</strong>
                <p>{toHours(examConfiguration.duration, false, false, false)}</p>
              </li>

              {examConfiguration.studentNotes &&
                <li>
                  <strong>{translation.exam_details.notes}</strong>
                  <p>{examConfiguration.studentNotes}</p>
                </li>
              }
            </ul>

            {this.state.permittedItems.length > 0 &&
              <ul className="data--alt data--separator">
                <li className="data__separator">
                  <strong>{translation.exam_details.permitted_items}</strong>

                  <ul className="data--inner">
                  {this.state.permittedItems.map(
                    (item, i) =>
                    <li key={i}>
                      <strong>{item.title}</strong>

                      {item.details &&
                        <p>{item.details}</p>
                      }
                    </li>
                  )}
                  </ul>
                </li>
              </ul>
            }
          </section>
  
          <section className="panel__section">
            <h2 className="panel__title panel__title--alt">
              {translation.process_heading}
            </h2>
  
            <ol className="flow">
              <li>
                <icons.iconUser />
                <span className="flow__title">
                  {translation.process.onboard}
                </span>
              </li>
              <li>
                <icons.icon_text />
                <span className="flow__title">
                  {translation.process.exam}
                </span>
              </li>
              <li>
                <icons.iconCheckCircle />
                <span className="flow__title">
                  {translation.process.complete}
                </span>
              </li>
            </ol>
          </section>
        </main>
      )
    } else {
      return (
        <div className={`panel panel--medium ${statusClass}`}>
          <h2 className="panel__title panel__title--alt">
            {translation.preparation.heading}
          </h2>

          {verifyId
            ? <p>{translation.preparation.intro}</p>
            : <p>{translation.preparation.intro_no_id}</p>
          }

          <ol className="flow flow--nonsequential">
            {/* Only Include Id Icon if it is a required item */}
            {verifyId && 
              <li>
                <icons.iconID />
              </li>
            }
            <li>
              <icons.iconLightbulb />
            </li>
            <li>
              <icons.iconCoffee />
            </li>
          </ol>

          <strong>{translation.preparation.break}</strong>
        </div>
      )
    }
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/Intro.js